import { render, staticRenderFns } from "./RgHistoryMenuButton.vue?vue&type=template&id=d66452b2&scoped=true"
import script from "./RgHistoryMenuButton.vue?vue&type=script&lang=js"
export * from "./RgHistoryMenuButton.vue?vue&type=script&lang=js"
import style0 from "./RgHistoryMenuButton.vue?vue&type=style&index=0&id=d66452b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66452b2",
  null
  
)

export default component.exports